export const farms = [
  {
    id: "boerderij-roskam",
    name: "Boerderij Roskam",
    location: "Noordoostpolder + Oversijssel, Netherlands",
    region: "East Holland",
    farmerName: "Klaas, Cor, Léon & Miranda Roskam",
    farmerQuote: "Having sheep is a way of living, it is part of who we are, it has shaped who we are.",
    heroImage: "/roskam_farm_four.jpg",
    images: [
      "/roskam_farm_four.jpg",
      "/roskam_farm_one.jpg",
      "/roskam_farm_two.jpg"
    ],
    storyShort: "Around 1985 a father and a son started farming with a few sheep, which slowly grew into a bigger farm of around 150 sheep in 2020. Since 2020 the farm has shrunk down to 65 sheep, but the passion for farming stays exactly the same.",
    storyFull: `Boerderij Roskam is located on the border of Noordoostpolder and Overijssel, with its land spread across two provinces and municipalities. The farm began around 1985, when a father and his son started keeping a small number of sheep. What started as a modest initiative gradually developed into a fully functioning sheep farm.

Over the years, the flock grew steadily through practical experience and daily work. Sheep farming became part of everyday life, shaping routines, responsibilities, and family involvement. Klaas, Cor, Léon, and Miranda all play a role in the farm, each contributing to its continuity and development.

By 2020, the farm had grown to approximately 150 sheep. The flock consists of a mix of Texelaars, Swifters, and Hampshire Down. This breeding combination results in large, strong sheep that are mostly white with a brown head, well suited to the local landscape.

After 2020, changes in circumstances led to a reduction in flock size to around 65 sheep. Despite this decrease, the commitment to sheep farming remained unchanged. 

As the farmers themselves say, “Having sheep is a way of living, it is part of who we are, it has shaped who we are.”. 

Today, Boerderij Roskam continues as a family farm where experience, care for the animals, and dedication to the land remain central.`,
    sheepBreed: "Mix of Texel, Swifters & Hemshire",
    flockSize: "~65 sheep",
    sustainabilityPractices: [
      "Rotational grazing to promote pasture health",
      "No antibiotics in preventive treatment",
      "Solar-powered farm buildings",
      "Local feed sourcing within 20km"
    ],
    certifications: ["Animal Welfare Approved", "Organic in Transition"],
    productsFromFarm: ["heritage-sweater-natural", "coastal-cardigan-slate", "winter-beanie-charcoal"]
  }
];
